// extracted by mini-css-extract-plugin
export default {"white":"switch-leco-user_white__VRmp3","purple":"switch-leco-user_purple__EDjuE","switch":"switch-leco-user_switch__9zCmh"};